<template>
  <div v-loading="loading" class="mt20">
    <el-alert v-if="error" :title="error" type="error" :closable="false" show-icon class="mb10" />
    <el-button v-if="error" size="mini" @click="load">重新加载</el-button>
    <template v-if="!logs">
      <el-descriptions v-if="summary" :column="3" border class="mb10">
        <el-descriptions-item label="当前画像">{{ summaryText }}</el-descriptions-item>
        <el-descriptions-item label="当前服务周期">{{ serviceCycleText(summary.serviceCycle) }}</el-descriptions-item>
        <el-descriptions-item label="累计符合次数">{{ summary.markCount || 0 }}</el-descriptions-item>
      </el-descriptions>
      <el-table :data="records" border size="small" empty-text="暂无画像或服务标记">
        <el-table-column label="序号" prop="seqNo" width="70" />
        <el-table-column label="画像结论" min-width="160">
          <template slot-scope="{row}">{{ portraitConclusionText(row.isPortrait30) }}</template>
        </el-table-column>
        <el-table-column label="服务周期" width="110">
          <template slot-scope="{row}">{{ serviceCycleText(row.serviceCycle) }}</template>
        </el-table-column>
        <el-table-column label="标记人" prop="markedByName" min-width="100" />
        <el-table-column label="标记时间" min-width="170">
          <template slot-scope="{row}">{{ timeText(row.markedAt) }}</template>
        </el-table-column>
        <el-table-column label="画像到期时间" min-width="170">
          <template slot-scope="{row}">{{ timeText(row.expireAt) }}</template>
        </el-table-column>
        <el-table-column label="来源跟进ID" prop="followRecordId" width="110" />
      </el-table>
    </template>
    <el-table v-else :data="records" border size="small" empty-text="暂无标记日志">
      <el-table-column label="操作时间" min-width="170">
        <template slot-scope="{row}">{{ timeText(row.createdTime) }}</template>
      </el-table-column>
      <el-table-column label="操作人" prop="operatorName" min-width="100" />
      <el-table-column label="操作" width="100">
        <template slot-scope="{row}">{{ actionText(row.action) }}</template>
      </el-table-column>
      <el-table-column label="变更前" min-width="220">
        <template slot-scope="{row}"><div class="portrait-log-value">{{ valueText(row.beforeValue) }}</div></template>
      </el-table-column>
      <el-table-column label="变更后" min-width="220">
        <template slot-scope="{row}"><div class="portrait-log-value">{{ valueText(row.afterValue) }}</div></template>
      </el-table-column>
      <el-table-column label="备注" prop="remark" min-width="150" />
    </el-table>
  </div>
</template>

<script>
import portraitApi from '@/api/client/customerPortrait'
import { serviceCycleText, portraitConclusionText } from '@/utils/customerPortrait'

export default {
  props: {
    customerId: { type: [Number, String], required: true },
    logs: { type: Boolean, default: false }
  },
  data() { return { loading: false, error: '', records: [], summary: null } },
  computed: {
    summaryText() {
      if (this.summary.portraitValid) return '符合3.0及以上画像 · 有效'
      if (this.summary.latestIsPortrait30 === true) return '曾标记符合 · 已到期'
      return portraitConclusionText(this.summary.latestIsPortrait30)
    }
  },
  watch: {
    customerId: { immediate: true, handler: 'load' },
    logs: 'load'
  },
  methods: {
    serviceCycleText,
    portraitConclusionText,
    timeText(value) {
      if (value === null || value === undefined || value === '') return '--'
      const time = this.dayjs(value)
      return time.isValid() ? time.format('YYYY-MM-DD HH:mm:ss') : '--'
    },
    actionText(action) { return ({ 1: '标记', 2: '自动失效', 3: '覆盖' }[action] || String(action || '-')) },
    valueText(value) {
      if (!value) return '-'
      try {
        const data = typeof value === 'string' ? JSON.parse(value) : value
        const parts = []
        if (Object.prototype.hasOwnProperty.call(data, 'isPortrait30')) parts.push(portraitConclusionText(data.isPortrait30))
        if (Object.prototype.hasOwnProperty.call(data, 'serviceCycle')) parts.push('服务周期：' + serviceCycleText(data.serviceCycle))
        if (data.expireAt) parts.push('画像到期：' + this.timeText(data.expireAt))
        return parts.length ? parts.join('\n') : JSON.stringify(data)
      } catch (e) { return String(value) }
    },
    async load() {
      if (!this.customerId) return
      this.loading = true
      this.error = ''
      this.records = []
      this.summary = null
      try {
        if (this.logs) {
          const { data } = await portraitApi.logs(this.customerId)
          this.records = Array.isArray(data) ? data : []
        } else {
          const [marks, summary] = await Promise.all([portraitApi.marks(this.customerId), portraitApi.summary(this.customerId)])
          this.records = Array.isArray(marks.data) ? marks.data : []
          this.summary = summary.data || null
        }
      } catch (e) { this.error = this.logs ? '标记日志加载失败，请重试' : '画像与服务标记加载失败，请重试' }
      finally { this.loading = false }
    }
  }
}
</script>

<style scoped>
.portrait-log-value { white-space: pre-wrap; word-break: break-word; }
</style>
